/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'

/**
 *     Import
 *     - Styles
 */
import './styles/Accordion.css'

export default class Accordion extends React.Component<any, any> {

    private accordionContent

    constructor(props: any) {
        super(props)
        this.state = {
            open: this.props.open || false,
            style: { maxHeight: (this.props.open) ? '10000px' : 0 },
        }
    }

    toggle = () => {
        this.setState({
            open: !this.state.open,
            style: { maxHeight: (this.state.open) ? '0px' : '10000px' },
        })

        if (this.props.onChange) {
            this.props.onChange()
        }
    }

    render() {
        const isDisabled = this.props.disabled
        return (
            <div className="accordion">
                <div
                    className={`accordion__header ${isDisabled ? 'accordion__disabled' : ''}`}
                    onClick={!isDisabled ? this.toggle : undefined}
                >
                    <div className="accordion__header__title">{this.props.title}</div>
                    <div className={`accordion__header__icon ${this.state.open ? 'open' : null}`}>
                        <DropdownArrowIcon color={`#fca61b`} />
                    </div>
                </div>
                <div
                    style={this.state.style}
                    className={`accordion__content ${this.state.open ? 'open' : null}`}
                    ref={(accordionContent) => this.accordionContent = accordionContent}
                >
                    {this.props.children}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Accordion/Accordion.tsx